import { db } from "../../services/firebase";
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  where,
  QueryConstraint,
} from "firebase/firestore";

export const getLatestBlogSlug = async (
  blogCategoryId?: number | null
): Promise<string | null> => {
  try {
    const blogRef = collection(db, "blog");

    const queryConstraints: QueryConstraint[] = [
      orderBy("dateTimeInEasternTime", "desc"),
      limit(1),
    ];

    if (typeof blogCategoryId === "number") {
      queryConstraints.unshift(where("blogCategoryId", "==", blogCategoryId));
    }

    const q = query(blogRef, ...queryConstraints);

    const snap = await getDocs(q);
    if (snap.empty) return null;

    return snap.docs[0].data().slug as string;
  } catch (err) {
    console.error("Error fetching articles blog slug:", err);
    throw err;
  }
};
